/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/
import Body from './Body';
import Footer from './Footer';
import TAIResultsPage from './AIResultsPage';

const AIResultPageTemp: any = TAIResultsPage;
AIResultPageTemp.Body = Body;
AIResultPageTemp.Footer = Footer;

const AIResultsPage = AIResultPageTemp;

export default AIResultsPage;
